import { onboarding } from '@services';

import qs from 'query-string';

import OnboardingThread, {
  IOnboardingThread,
  IOnboardingThreadApi,
  IPaginationResultThreads,
} from '@models/OnboardingThread.model';

interface IRequest {
  threadId: string;
  perPage?: number;
  page?: number;
}

const getMessagesByThread = async ({
  threadId,
  page,
  perPage,
}: IRequest): Promise<IPaginationResultThreads<IOnboardingThread>> => {
  const query = {
    threadId,
    perPage,
    page,
  };

  const queryString = qs.stringify(query);

  const { data: messages } = await onboarding.get<
    IPaginationResultThreads<IOnboardingThreadApi>
  >(`/api/v1/chat/text?${queryString}`);

  return OnboardingThread.arrayPaginatedFromApiModel(messages);
};

export { getMessagesByThread };
